import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import format from '@/common/utilities/format.js';

export default {
    name: 'propertyHistory',
    components: {
        mvtCollapse,
    },
    props: ['disableCollapse', 'isActive'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getPriceHistory']),
        description() {
            var latest = this.getPriceHistory && this.getPriceHistory[0];
            let priceDesktop = latest.status === 'Sold' && this.dpp.hidePropertyPrice ? '—' : latest.priceDesktop;
            let dateDesktop = latest.dateDesktop || '—';
            if (latest && (latest.dateDesktop || latest.priceDesktop)) {
                if (latest.priceChangeTag === 2) {
                    return `Price Changed on ${dateDesktop} to ${priceDesktop}${latest.isRental ? '/Mo' : ''}`;
                }
                return `${latest.status} on ${dateDesktop} for ${priceDesktop}${latest.isRental ? '/Mo' : ''}`;
            }
            return '';
        },
        historyData() {
            let group = [];
            if (this.getPriceHistory && this.getPriceHistory.length) {
                let history = this.getPriceHistory.filter((item) => {
                    if (this.hideSoldHistory()) {
                        return item.status && !/sold/i.test(item.status);
                    }
                    return true;
                });
                history = history.sort((a, b) => {
                    return new Date(b.date) - new Date(a.date);
                });
                let groupKeys = history.map((item) => this.getHistoryGroupKey(item));
                groupKeys = [...new Set(groupKeys)];
                groupKeys.forEach((groupKey) => {
                    let dateByGroup = history.find((item) => this.getHistoryGroupKey(item) === groupKey).date;
                    let groupItem = {
                        groupKey: groupKey,
                        dateMonthYear: dateByGroup ? format.formateMonthYear(dateByGroup) : '',
                        history: [],
                    };
                    history.forEach((item) => {
                        if (this.getHistoryGroupKey(item) === groupKey) {
                            groupItem.history.push(item);
                        }
                    });
                    group.push(groupItem);
                });
            }
            return group;
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        hideHistory() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideHistory') >= 0;
        },
        hideSoldHistory() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideSoldHistory') >= 0;
        },
        shouldShowHistoryLogo() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideHistoryLogo') === -1;
        },
        getClass(priceChangeTag) {
            var classMapper = {
                1: 'text-green',
                2: 'text-red',
            };
            return classMapper[priceChangeTag] || '';
        },
        getHistoryGroupKey(record) {
            if (record.dataSource === 'public_record') {
                return `public_record_${record.historyId || record.date}`;
            }
            return record.mlsNumber;
        },
        isPublicRecordGroup(record) {
            return record && record.dataSource === 'public_record';
        },
        mlsLogoSrc(mlsId) {
            if (!this.dpp.showAsPR && mlsId) {
                return this.glb.cdnUrl + 'images/desktop/logo/logo_' + mlsId + '.png';
            }
        },
    },
};
